import React from 'react';
import 'twin.macro';
import { Item } from '@teetsh/app/src/types/programmations';
import { Element } from './Element';

interface Props {
  items: Item[];
}

export function Block(props: Props) {
  const { items } = props;
  return (
    <div tw="flex flex-1 flex-col gap-y-2 min-w-0">
      {items.map((item, idx) => (
        <div key={idx}>
          <Element
            value={item.value}
            color={item.color}
            attachments={item.attachments}
            sequence={item.sequence}
            ficheDePrep={item.ficheDePrep}
            tag={
              item.domaine
                ? { label: item.domaine.name, color: item.domaine.color }
                : undefined
            }
          />
        </div>
      ))}
    </div>
  );
}
